import { render } from "./AboutResume.vue?vue&type=template&id=129ad5a0&scoped=true"
import script from "./AboutResume.vue?vue&type=script&lang=js"
export * from "./AboutResume.vue?vue&type=script&lang=js"

import "./AboutResume.vue?vue&type=style&index=0&id=129ad5a0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-129ad5a0"]])

export default __exports__